import type { LoadingStates } from 'Store'
import { createAsyncThunkWithErrorHandling, getAxiosInstance } from 'Util/ApiClient'
import actionGenerator from 'Util/actionGenerator'
import { createSlice } from '@reduxjs/toolkit'

export interface AllowedClientState {
  allowedClients: string[]
  allowedClientsLoading: LoadingStates
}

const initialState: AllowedClientState = {
  allowedClients: [],
  allowedClientsLoading: 'idle'
}

export interface FetchAllowedClientsListParams {
  exclude_manager_client?: boolean
}

const fetchAllAllowedClients = createAsyncThunkWithErrorHandling<
  string[],
  FetchAllowedClientsListParams | undefined
>('spmAllowedClient/fetchAllAllowedClients', async data => {
  const { ...params } = data
  const response = await getAxiosInstance().get<string[]>(`/api/v1/spm-allowed-client/`, { params })
  return response.data
})

const genericActions = actionGenerator('spmAllowedClient')

const spmAllowedClientSlice = createSlice({
  name: genericActions.name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder

      /* All allowed clients */
      .addCase(fetchAllAllowedClients.fulfilled, (state, { payload }) => {
        state.allowedClients = payload
        state.allowedClientsLoading = 'fulfilled'
      })
      .addCase(fetchAllAllowedClients.pending, state => {
        state.allowedClients = initialState.allowedClients
        state.allowedClientsLoading = 'pending'
      })
      .addCase(fetchAllAllowedClients.rejected, state => {
        state.allowedClientsLoading = 'rejected'
      })
  }
})

export default spmAllowedClientSlice.reducer

export { fetchAllAllowedClients }
